import React, { useEffect, useState, useRef } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import PaginationTable from '../../pagination/Pagination4';
import { formatDateToDD_MM_YYYY } from "../../Utils/DateUtils";


const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const KeyRegisterAllotDist_data = async (params) => {
    const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/sdms/FPS_Offline_Trans_Details`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),

    });

    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const FPS_Offline_Trans_Details = ({ month, year, dist_code, fps_id, heading }) => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(heading);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [searchQuery, setSearchQuery] = useState('');
    const [totals, setTotals] = useState([]); // State for storing column totals
    const detailsTrans = useRef(null);

    const calculateTotals = (data) => {

        const columnCount = data[0].commoditylist.length;
        const columnTotals = new Array(columnCount).fill(0); // Initialize an array for totals

        data.forEach(item => {
            item.commoditylist.forEach((colItem, colIndex) => {
                columnTotals[colIndex] += parseFloat(colItem.allot_qty) || 0; // Sum each column's allot_qty
            });

        });

        setTotals(columnTotals);
    };

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await KeyRegisterAllotDist_data({ month, year, dist_code, fps_id });

                if (Array.isArray(response_data.data)) {
                    setReportData(response_data.data);

                    calculateTotals(response_data.data);

                } else {
                    setReportData([]);
                }
            } catch (error) {
                console.log(error);
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, dist_code, fps_id]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (value) => {
        setRowsPerPage(value === 'all' ? reportData.length : parseInt(value, 10));
        setPage(0);
    };

    const filteredData = reportData.filter(item => {
        const searchTerm = searchQuery.toLowerCase();


        if (!searchTerm) return true;


        const mainFieldsMatch =
            item.existing_rc_number?.toLowerCase().includes(searchTerm) ||
            item.scheme_short_name?.toLowerCase().includes(searchTerm) ||
            item.trans_status?.toLowerCase().includes(searchTerm) ||
            item.receipt_id?.toLowerCase().includes(searchTerm) ||
            item.transdate?.toLowerCase().includes(searchTerm) ||
            item.transtime?.toLowerCase().includes(searchTerm) ||
            item.offlinedate?.toLowerCase().includes(searchTerm) ||
            item.offlinetime?.toLowerCase().includes(searchTerm) ||
            item.amount?.toString().toLowerCase().includes(searchTerm) ||
            item.port_check?.toLowerCase().includes(searchTerm) ||
            item.trans_time?.toLowerCase().includes(searchTerm);

        const commodityMatch = item.commoditylist?.some(commodity =>
            commodity.comm_short?.toLowerCase().includes(searchTerm) ||
            commodity.allot_qty?.toString().includes(searchTerm)
        );

        return mainFieldsMatch || commodityMatch;
    });

    // Ensure pagination logic is correct
    const paginatedData = filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && detailsTrans.current) {
            // detailsTrans.current.scrollIntoView({ behavior: 'smooth' , block: 'end'});
            const elementPosition = detailsTrans.current.offsetTop;
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
        }
    }, [loading, error, reportData]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }

    // if (error) {
    //      return <div className="mainhead" align="center">Internal error</div>;
    // }

    if (reportData.length === 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }

    return (
        <>
            <br /><br />
            <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'end', marginBottom: '20px', marginRight: '10%' }}>
                <input type="text"
                    placeholder="Search RC Id"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{ padding: '8px', width: '300px' }}
                />
            </div>
            <br />

            <table align="center" width="90%" border={1} ref={detailsTrans}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={10 + reportData[0].commoditylist.length}>
                            {tabHeading + ' for FPS Id : ' + fps_id + ' ' + MonthC[parseInt(month) - 1] + '-' + year}
                        </th>
                    </tr>
                    <tr className="tableheader">
                        <th rowSpan={2}>Sl.No</th>
                        <th rowSpan={2}>RC No</th>
                        <th rowSpan={2}>Scheme</th>
                        <th rowSpan={2}>Avail Type</th>
                        <th rowSpan={2}>Receipt No</th>
                        <th rowSpan={2}>Uploaded<br />Date</th>
                        <th rowSpan={2}>Transaction<br />Date</th>

                        <th colSpan={reportData[0].commoditylist.length}>Qty in Kgs</th>

                        <th rowSpan={2}>Amount</th>
                        <th rowSpan={2}>Portability</th>
                        <th rowSpan={2}>Auth Trans Time</th>
                    </tr>
                    <tr className="tableheader">
                        {reportData[0].commoditylist.map((item, index) => (
                            <th key={index}>{item.comm_short || ''}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {paginatedData.map((item, index) => (
                        <tr key={item.receiptId}>
                            <td style={{ textAlign: 'center' }}>{index + 1 + (page * rowsPerPage)}</td>
                            <td style={{ textAlign: 'left' }}>{item.existing_rc_number}</td>
                            <td style={{ textAlign: 'left' }}>{item.scheme_short_name}</td>
                            <td style={{ textAlign: 'left' }}>{item.trans_status}</td>
                            <td style={{ textAlign: 'left' }}>{item.receipt_id}</td>
                            <td style={{ textAlign: 'left' }}>{item.transdate} {item.transtime}</td>
                            <td style={{ textAlign: 'left' }}>{item.offlinedate} {item.offlinetime}</td>

                            {item.commoditylist.map((item1, index) => (
                                <td key={index} style={{ textAlign: 'right' }}>{item1.allot_qty || '0'}</td>
                            ))}

                            <td style={{ textAlign: 'right' }}>{item.amount}</td>
                            <td style={{ textAlign: 'left' }}>{item.port_check}</td>
                            <td style={{ textAlign: 'left' }}>{item.trans_time}</td>
                        </tr>
                    ))}

                </tbody>
                <tfoot>
                    <tr className="tableheader">
                        <td colSpan={7}>Total</td>
                        {totals.map((total, index) => (
                            <td style={{ textAlign: 'right', fontWeight: 'bold' }} key={index}>{total.toFixed(3)}</td>
                        ))}
                        <td colSpan={3} style={{ textAlign: 'right' }}> </td>

                    </tr>
                </tfoot>
            </table>
            <br />
            <br />
            <div width="75%" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '90%', marginBottom: '5%' }}>
                <PaginationTable
                    count={filteredData.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </div>

        </>
    );
};

export default FPS_Offline_Trans_Details;
